'use client';

import Image from 'next/image';
import { Button } from '../ui/button';
import type { ButtonHTMLAttributes } from 'react';
import { cn } from '../cn';
import { useShell } from '../provider';

type HeaderAuthTriggerProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  isLoggedIn: boolean;
  avatar?: string;
  label?: string;
};

export function HeaderAuthTrigger({
  isLoggedIn,
  avatar,
  label,
  className,
  ...buttonProps
}: HeaderAuthTriggerProps) {
  const { config } = useShell();
  const defaultAvatar = config.defaultAvatarSrc;
  const accountLabel = label ?? (isLoggedIn ? 'Tài khoản' : 'Đăng nhập');

  if (!isLoggedIn) {
    return (
      <Button
        type="button"
        variant="default"
        aria-label="Đăng nhập"
        className={cn(
          'text-on-primary leading-sm hidden h-11 rounded-[14px] px-4 py-2 text-base font-semibold xl:flex',
          className
        )}
        {...buttonProps}
      >
        {accountLabel}
      </Button>
    );
  }

  return (
    <button
      aria-label={`Mở menu tài khoản${label ? ` của ${label}` : ''}`}
      type="button"
      className={cn(
        'hover:text-primary text-ui-base leading-sm hidden h-11 items-center justify-center gap-2 rounded-[14px] text-white xl:flex',
        'size-11 overflow-hidden p-0',
        className
      )}
      {...buttonProps}
    >
      <Image
        src={avatar || defaultAvatar}
        alt=""
        width={44}
        height={44}
        sizes="44px"
        className="size-11 rounded-full object-cover"
        loader={config.imageLoader}
        unoptimized={!avatar}
      />
    </button>
  );
}
